import React, { useMemo } from "react";
import { Card, Rate, Button, Typography, Row, Col, Image,Tooltip } from "antd";
import { StarOutlined } from "@ant-design/icons";
import AmazonLogo from "../../assests/Images/amazon.png";
import WalmartLogo from "../../assests/Images/walmart.png";
import TargetLogo from "../../assests/Images/target.png";
import BestBuyLogo from "../../assests/Images/best_buy1.png";
import HomeDepotLogo from "../../assests/Images/homedepot1.png";
import KrogerLogo from "../../assests/Images/kroger.png";
import WayfairLogo from "../../assests/Images/wayfair1.png";
import "./product-card.css";  // import CSS
import { formatNumber } from "../../shared/utils";

const { Text } = Typography;

const logos = {
  Amazon: AmazonLogo,
  Walmart: WalmartLogo,
  Target: TargetLogo,
  Bestbuy: BestBuyLogo,
  BestBuy: BestBuyLogo,
  Homedepot: HomeDepotLogo,
  HomeDepot: HomeDepotLogo,
  Kroger: KrogerLogo,
  Wayfair: WayfairLogo,
};

export default function ProductCard({
  image,
  display_title,
  title,
  rating,
  reviews,
  price,
  unit_price,
  store,
  link,
  buttonColor,
  fontColor,
  unit,
  capacity_per_item,
  is_large_size,
  items_per_pack,

}) {
  const stableButtonColor = useMemo(() => buttonColor, [buttonColor]);
  const handleCardClick = () => window.open(link, "_blank");

  return (
    <Card
      hoverable

      className="product-card"
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        cursor: "pointer",
      }}
      cover={
        <div
          style={{
            // height: 180,
            padding:"6px 0px 0px 0px",
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
            background: "#ffffff",
          }}
        >
          <img
            alt={title}
            src={image}
            className="product-card-image"
            />
        </div>
      }
    >
      <div style={{ flexGrow: 1 }}>
        {/* title */}
        <Tooltip title={title} placement="bottom">
          <Text strong className="product-card-title">
            {display_title ? display_title?.length > 70 ? `${display_title.substring(0, 70)}...` : display_title : title?.length > 70 ? `${title.substring(0, 70)}...` : title}
          </Text>
        </Tooltip>

        {(is_large_size || items_per_pack > 1) && (
          <Text type="secondary" className="product-card-subtitle">
            {capacity_per_item} {unit} - {items_per_pack} pack
          </Text>
        )}

        {/* Rating + Reviews */}
        <div style={{ margin: "4px 0" }}>
        {rating && rating > 0 ? (
            <div style={{ display: "flex", alignItems: "center", }}>
            <Text className="product-card-rating">{rating}</Text>
            <Rate disabled value={rating} allowHalf />
            <Text className="product-card-rating-review" type="secondary">({formatNumber(reviews)})</Text>
            </div>
        ) : (
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            {/* <StarOutlined style={{ fontSize: 14, color: "#ccc" }} />
            <Text type="secondary">No Rating Yet</Text> */}
            </div>
        )}
        </div>


        {/* Price */}
        <div style={{ margin: "6px 0" }}>
        <div style={{ display: "flex", alignItems: "center", }}>
          <Text strong className="product-card-price">
            ${price ? Math.floor(price) : 0}
            <sup>{price ? String(price).split(".")[1] || "00" : "00"}</sup>
            <span className="product-card-price-unit">
              (${Number(unit_price).toFixed(3)}/{unit})
            </span>
          </Text>{" "}
          {/* {unit_price != null && unit && (
            <Text className="product-card-price-unit" type="secondary">
              (${Number(unit_price).toFixed(3)}/{unit})
            </Text>
          )} */}
          </div>
        </div>
      </div>

      {/* Logo + Button pinned at bottom */}
      <div className="product-footer">
      {logos[store] && (
        <Image
          src={logos?.[store]}
          alt={store}
          preview={false}
          className="store-logo"
          loading="lazy"
        />
      )}

      <Button
        type="primary"
        size="small"
        block
        className="product-link-btn"
        href={link}
        target="_blank"
        style={{background:buttonColor,color:fontColor}}
      >
        More Details
      </Button>
</div>

    </Card>
  );
}